import { useRemoteConfig } from "@/lib/queries/remote-config";

import { useConfigValue } from "../queries/config";

export const useBufferConfig = () => {
  const [bufferSize] = useConfigValue("bufferSize");
  const { data: remoteConfig } = useRemoteConfig();
  return remoteConfig.bufferSize[bufferSize];
};
